import Base from '../base.js'
import { statusResponse } from '../responseService'
export default class Essay extends Base {
  constructor () {
    super('/essays')
  }

  sendEssayImage = ($data) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('essayImage', $data.essayImage, 'essayImage')
      formData.append('theme_id', $data.themeId)
      formData.append('draft', false)
      this.http.post(this.api, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        resolve(response)
      }).catch((err) => {
        console.log(err)
        reject(statusResponse(err, 'create'))
      })
    })
  }

  sendCorrection = ($id, $data) => {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.api}/correct/${$id}`, $data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        resolve(response)
      }).catch((err) => {
        console.log(err)
        reject(statusResponse(err, 'create'))
      })
    })
  }

  getCorrectedEssay = ($id) => {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api}/corrected/${$id}`).then((response) => {
        resolve(response)
      }).catch((err) => {
        console.log(err)
        reject(statusResponse(err, 'create'))
      })
    })
  }

  listEssayToReviewer = () => {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api}/to-correct-by-reviewer`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'to-correct-by-reviewer'))
      })
    })
  }

  getCorrected = () => {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api}/corrected`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'corrected'))
      })
    })
  }

  getCorrectedEssays = () => {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api}/corrected-essays`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'corrected'))
      })
    })
  }

  getCountToCorrect = () => {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api}/number-to-correct`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'number-to-correct'))
      })
    })
  }

  listEssayDrafts = () => {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api}/drafts`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'drafts'))
      })
    })
  }
}
